import Link from 'next/link';
import { useRouter } from 'next/router';
import classes from './MoreArticles.module.scss';

const MoreArticles = ({ data, ctaText }) => {
    const router = useRouter();

    const { title, articles } = data;

    let listToSort;

    if (articles?.data) listToSort = [...articles.data];
    else return null;

    return (
        <div className={classes.oMoreArticles}>
            <div className={`${classes.oContainer} container`}>
                <h3 className={`${classes.aBlockTitle} fnt24`}>{title}</h3>
                <div className={`row`}>
                    {listToSort
                        .sort((a, b) =>
                            a.attributes.display_date < b.attributes.display_date ? 1 : -1
                        )
                        .map((cardData) => (
                            <div
                                key={cardData.id}
                                className={`${classes.oCardColumn} col-12 col-md-4`}
                            >
                                <div className={classes.oArticleCard}>
                                    <div className={classes.mCardBody}>
                                        <h3 className={`${classes.aTitle} fnt30`}>
                                            {cardData.attributes.title}
                                        </h3>
                                        <div className={`${classes.mText} fnt16f`}>
                                            {cardData.attributes.intro_text}
                                        </div>
                                        <Link
                                            href={{
                                                pathname: `articles/${cardData.attributes.slug}`,
                                                query: `lang=${
                                                    router.query?.lang || router.defaultLocale
                                                }`
                                            }}
                                        >
                                            <a className={`${classes.aTextLink} aTextLink`}>
                                                {ctaText}
                                            </a>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default MoreArticles;
